export default __webpack_public_path__ + "files/53ce94abb6d1dee43dd34d93f510071f.gif";